<mat-form-field class="async-selector">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select [placeholder]="placeholder"
              [formControl]="selectControl"
              [required]="required"
              [multiple]="multiple">
    <mat-option *ngFor="let option of selectorOptions | async"
                [value]="option[value]"
                [disabled]="disableOptionKey ? option[disableOptionKey] : false">
      {{ option[viewValue] }}
    </mat-option>
  </mat-select>

  <ng-content select="mat-hint"></ng-content>
  <ng-content select="mat-error"></ng-content>

  <mat-progress-bar *ngIf="isLoading" class="async-selector-loader" mode="indeterminate"></mat-progress-bar>
</mat-form-field>
